"use client"
import { Box, useMediaQuery } from "@mui/material"
import { styled } from "@mui/material/styles"
import React from "react"
import type { Theme } from "theme/theme"

export type MediaQueryComponentProps = {
  aboveTheFold?: boolean
  children?: React.ReactNode
  className?: string
}

export const useCustomQuery = (minWidth: number) =>
  useMediaQuery(`(min-width:${minWidth}px)`)

export const useIsDesktop = () =>
  useMediaQuery<Theme>((theme) => theme.breakpoints.up("md"))

/**
 * Mobile-only content using CSS media queries (SSR-safe)
 * Equivalent to: <Hidden mdUp>...</Hidden>
 */
const MobileWrapper = styled(Box)(({ theme }) => ({
  display: "contents",
  [theme.breakpoints.up("md")]: {
    display: "none",
  },
}))

/**
 * Desktop-only content using CSS media queries (SSR-safe)
 * Equivalent to: <Hidden smDown>...</Hidden>
 */
const DesktopWrapper = styled(Box)(({ theme }) => ({
  display: "none",
  [theme.breakpoints.up("md")]: {
    display: "contents",
  },
}))

/**
 * Mobile-only content
 * Equivalent to: <Hidden mdUp>...</Hidden>
 */
export const Mobile = ({ children, className }: MediaQueryComponentProps) => {
  return <MobileWrapper className={className}>{children}</MobileWrapper>
}

/**
 * Desktop-only content
 * Equivalent to: <Hidden smDown>...</Hidden>
 */
export const Desktop = ({ children, className }: MediaQueryComponentProps) => {
  return <DesktopWrapper className={className}>{children}</DesktopWrapper>
}

/** Optional IE/Edge media queries (legacy fallback) */
export const IEMediaQuery =
  "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)"
export const EdgeMediaQuery = "@supports (-ms-ime-align:auto)"
